import { Injectable } from '@angular/core';
import { UtilityService } from '../../../core/services/utility.service';
import { SmDataService } from './sm-data.service';
import { SmService } from './sm.service';
import { CompleteTripModalComponent } from 'src/app/modals/sm/complete-trip-modal/complete-trip-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TimeoutService } from 'src/app/core/services/timeout.service';
import { Router } from '@angular/router';
import { EventService } from '../../../core/services/event.service';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class SmSharedService {
  public format: any;

  constructor(private smService: SmService, public smDataService: SmDataService, private utilityService: UtilityService, private ngbModalService: NgbModal,
    private timeoutService: TimeoutService, private router: Router, private eventService: EventService) {
    this.format = this.utilityService.getDateFormat();
  }


  public getClockInStatus() {
    this.smService.getClockInStatus().then((response: any) => {
      if (response != null) {
        this.smDataService.clockInStatus = response;
        if (this.smDataService.clockInStatus.ClockTime != null) {
          this.smDataService.clockInStatus.ClockTimeDisplay = moment(this.smDataService.clockInStatus.ClockTime).utc().format('LT');
          this.smDataService.clockInStatus.ClockDateDisplay = moment(this.smDataService.clockInStatus.ClockTime).utc().format("YYYY-MM-DD");
        }
      } else {
        this.smDataService.clockInStatus = null;
      }
      this.utilityService.closeModal();
      this.eventService.broadcast('navClockStatus', this.smDataService.clockInStatus);

      this.smDataService.clockEmpty = false;

      if (this.smDataService.clockInStatus == null)
        this.smDataService.clockEmpty = true;
    });
  }

  public getSignature() {
    this.smDataService.signatures = [];
    var scopesString = "";
    $.each(this.smDataService.tempClose, function (key, val) {
      scopesString += val.SMWorkOrderScopeID + ",";
    })

    this.smService.getSignatures(this.smDataService.currentWorkOrder.SMTripID, scopesString).then((response: any) => {
      this.smDataService.signatures = response;
      this.smDataService.signatures.forEach((val, key) => {
        val.SignatureImage = "data:image/png;base64," + val.SignatureImage;
        val.dateSignedString = moment(val.SignDate).format("MM/DD/YYYY");
      })

      this.router.navigate(['/sm/closeout']);
    });
  }

  public modifyNewRow(data) {
    if (data != null) {
      if (data.ScheduledDate != null) {
        data.date = moment(data.ScheduledDate).utc().format("YYYY/MM/DD");
        data.ScheduledDateDisplay = moment(data.ScheduledDate).utc().format("DD/MMM");
      }
      if (data.ScheduledEndDate != null) {
        data.ScheduledEndDateDisplay = moment(data.ScheduledEndDate).utc().format("DD/MMM");
      }
      if (data.TripDetails != null && data.TripDetails != "") {
        data.TripDetailsHtml = data.TripDetails;
      }
      if (data.TripNotes != null && data.TripNotes != "") {
        data.TripNotesHTML = data.TripNotes;
      } else {
        data.TripNotesHTML = null;
      }
      if (data.UDFieldData != null) {
        var temp = new DOMParser();
        var temp2 = temp.parseFromString(data.UDFieldData, "text/xml");
        var temp3 = this.utilityService.xmlToJson(temp2);
        var temp4 = [];
        $.each(temp3.UDFieldData.SMWorkOrderUDPivot, function (key2, val2) {
          if (val2.attributes != null)
            temp4.push({ ColumnName: val2.attributes.Label, FieldValue: val2.attributes.FieldValue, SMWorkOrderID: val2.attributes.SMWorkOrderID, DataType: val2.attributes.DataType });
          else
            temp4.push({ ColumnName: val2.Label, FieldValue: val2.FieldValue, SMWorkOrderID: val2.SMWorkOrderID, DataType: val2.DataType });
        });
        data.udDisplay = temp4;
      }
      if (data.ScopeData != null) {
        var temp = new DOMParser();
        var temp2 = temp.parseFromString(data.ScopeData, "text/xml");
        var temp3 = this.utilityService.xmlToJson(temp2);
        var temp4 = [];
        var BillableHours = 0.000, HasBilledMatlCount = 0, HasPOCount = 0, LaborHours = 0.000, TotalItems = 0, Units = 0.000, BudgetLaborHours = 0;

        Object.entries(temp3.WorkOrderScopes.Scope).forEach(([key2, val2]: any) => {
          if (val2.attributes != null && val2.attributes.SMWorkOrderScopeID != null) {
            temp4.push({
              SMWorkOrderScopeID: val2.attributes.SMWorkOrderScopeID, Scope: val2.attributes.Scope, ScopeDescription: val2.attributes.ScopeDescription, UniqueAttchID: val2.attributes.UniqueAttchID,
              SMCo: data.SMCo, SummaryLaborHours: val2.attributes.SummaryLaborHours, SummaryBillableHours: val2.attributes.SummaryBillableHours, SummaryUnits: val2.attributes.SummaryUnits,
              POLineCount: val2.attributes.POLineCount, SummaryTotalItems: val2.attributes.SummaryTotalItems, MaterialItemCount: val2.attributes.MaterialItemCount,
              IsLumpSum: (val2.attributes.IsLumpSum == "0" ? false : true), BudgetLaborHours: val2.attributes.BudgetLaborHours
            });
            if (val2.attributes.IsLumpSum == "0") {
              BillableHours += parseFloat(val2.attributes.SummaryBillableHours);
            }
            LaborHours += parseFloat(val2.attributes.SummaryLaborHours);
            Units += parseFloat(val2.attributes.SummaryUnits);
            TotalItems += parseInt(val2.attributes.SummaryTotalItems);
            HasBilledMatlCount = (parseInt(val2.attributes.MaterialItemCount) > 0 ? (HasBilledMatlCount += parseInt(val2.attributes.MaterialItemCount)) : HasBilledMatlCount);
            HasPOCount = (parseInt(val2.attributes.POLineCount) > 0 ? (HasPOCount += parseInt(val2.attributes.POLineCount)) : HasPOCount);
            BudgetLaborHours += (val2.attributes.BudgetLaborHours != null ? parseFloat(val2.attributes.BudgetLaborHours) : 0);
          } else {
            var singleVal = temp3.WorkOrderScopes.Scope;

            if (singleVal.attributes.SMWorkOrderScopeID != null && key2 == "attributes") {
              temp4.push({
                SMWorkOrderScopeID: singleVal.attributes.SMWorkOrderScopeID, Scope: singleVal.attributes.Scope, ScopeDescription: singleVal.attributes.ScopeDescription, UniqueAttchID: singleVal.attributes.UniqueAttchID, SMCo: data.SMCo,
                SummaryLaborHours: singleVal.attributes.SummaryLaborHours, SummaryBillableHours: singleVal.attributes.SummaryBillableHours, SummaryUnits: singleVal.attributes.SummaryUnits, POLineCount: singleVal.attributes.POLineCount,
                SummaryTotalItems: singleVal.attributes.SummaryTotalItems, MaterialItemCount: singleVal.attributes.MaterialItemCount, IsLumpSum: (singleVal.attributes.IsLumpSum == "0" ? false : true),
                BudgetLaborHours: singleVal.attributes.BudgetLaborHours
              });
              if (singleVal.attributes.IsLumpSum == "0") {
                BillableHours += parseFloat(singleVal.attributes.SummaryBillableHours);
              }
              LaborHours += parseFloat(singleVal.attributes.SummaryLaborHours);
              Units += parseFloat(singleVal.attributes.SummaryUnits);
              TotalItems += parseInt(singleVal.attributes.SummaryTotalItems);
              HasBilledMatlCount = (parseInt(singleVal.attributes.MaterialItemCount) > 0 ? (HasBilledMatlCount += parseInt(singleVal.attributes.MaterialItemCount)) : HasBilledMatlCount);
              HasPOCount = (parseInt(singleVal.attributes.POLineCount) > 0 ? (HasPOCount += parseInt(singleVal.attributes.POLineCount)) : HasPOCount);
              BudgetLaborHours += (singleVal.attributes.BudgetLaborHours != null ? parseFloat(singleVal.attributes.BudgetLaborHours) : 0);
            }
          }
        });
        
        data.ScopeDataDisplay = temp4;
        data.SummaryBillableHours = BillableHours;
        data.SummaryHasBilledMatl = (HasBilledMatlCount > 0 ? true : false);
        data.SummaryHasPO = (HasPOCount > 0 ? true : false);
        data.SummaryLaborHours = LaborHours;
        data.SummaryTotalItems = TotalItems;
        data.SummaryUnits = Units;
        data.BudgetLaborHours = BudgetLaborHours;
      }
      if (data.PriorityColor != null) {
        var tempColor = this.utilityService.hexToRgb(data.PriorityColor);
        if ((tempColor.r * 0.299 + tempColor.g * 0.587 + tempColor.b * 0.114) > 186)
          data.fontColor = "#363545"
        else
          data.fontColor = "#ffffff";
      } else {
        data.PriorityColor = "#C81922"
        data.fontColor = "#363545"
      }
      data.TripName = ((data.ScheduledDate != null) ? data.ScheduledDateDisplay + " -" : "")
        + (data.ScheduledEndDate != null ? data.ScheduledEndDateDisplay + " -" : "")
        + (data.ScheduledTime != null ? data.ScheduledTime + (data.SMTripID != -2 ? " -" : "") : "")
        + (data.SMTripID != -2 ? ("WO #" + data.WorkOrder) : "");
      data.FullAddress = [data.Address1, data.Address2, data.City, data.State, data.Zip].filter(Boolean).join(" ");
    }
  }

  public getScopePurchaseOrders(data, closeOut, index) {
    var url = "?sMWorkOrderScopeID=" + (data == null ? this.smDataService.currentWorkOrderScopeData.SMWorkOrderScopeID : data.SMWorkOrderScopeID);
    this.smService.getScopePurchaseOrders(url).then((response: any) => {
      if (this.smDataService.completedList == null) {
        if (closeOut) {
          this.smDataService.completedList = ({ Equipment: [], Labor: [], Misc: [], Inventory: [], PO: [] });
        } else {
          this.smDataService.completedList = {};
        }
      }
      var totalAmount = 0;
      var taxCharge = 0;
      this.smDataService.completedList["PO"] = [];
      response.forEach((val, key) => {
        if (val.PODate != null) {
          val.PODateDisplay = moment(val.PODate).utc().format(this.format.substr(0, 8).toUpperCase());
        }
        totalAmount += val.PriceTotal;
        taxCharge += val.TaxAmount;
        this.smDataService.completedList["PO"].push(val);
      });

      if (closeOut) {
        if (this.smDataService.closeDetailsList[index].IsLumpSum) {
          totalAmount = this.smDataService.closeDetailsList[index].LumpSumAmt;
          taxCharge = this.smDataService.closeDetailsList[index].TotalWOTaxAmount;
          this.smDataService.totalTripCharge = totalAmount;
          this.smDataService.totalTaxCharge = taxCharge;
        } else {
          this.smDataService.totalTripCharge += totalAmount;
          this.smDataService.totalTaxCharge += taxCharge;
        }
        this.smDataService.closeDetailsList[index]["completedList"] = JSON.parse(JSON.stringify(this.smDataService.completedList));
        if (isNaN(this.smDataService.closeDetailsList[index]["totalAmount"])) {
          this.smDataService.closeDetailsList[index]["totalAmount"] = 0;
        }
        this.smDataService.closeDetailsList[index]["totalAmount"] = totalAmount;
      }
    });
  }

  public getSignerContacts() {
    this.smService.getSignerContacts(this.smDataService.currentWorkOrder.SMWorkOrderID, this.smDataService.currentWorkOrder.SMWorkOrderID).then((response: any) => {
      this.smDataService.signDisList = {};
      this.smDataService.signOffList = [];
      this.smDataService.signOffListRaw = [];
      this.smDataService.emailCCList = [];
      response.forEach((val, key) => {
        val.Display = val.FirstName + " " + val.LastName + (val.Organization != null ? " - " + val.Organization : "");
        if (val.AlwaysEmail) {
          this.smDataService.emailCCList.push(val);
        }
        this.smDataService.signOffList.push(val);
        this.smDataService.signOffListRaw.push(val);
      })
      if (this.smDataService.currentScopeSettings != null && this.smDataService.currentScopeSettings.WorkCompletedCCEmailList != null) {
        this.smDataService.currentScopeSettings.WorkCompletedCCEmailList.split(",").forEach((val, key) => {
          this.smDataService.emailCCList.push({ "Email": val.trim() });
        })
      }
      this.smDataService.signOffList.push({ Email: "", FirstName: "", LastName: "", Organization: "", Title: "", Display: "Add a new contact...", HQContactID: -1 });
      this.smDataService.signOffList.unshift({ Email: "", FirstName: "", LastName: "", Organization: "", Title: "", Display: "No Signer", HQContactID: -2 });
    });
  }

  public resetPage(loadTrip, clockOut, routeToManage) {
    if (routeToManage)
      this.router.navigate(['/sm/manage']);
    this.smDataService.allShow = true;
    this.smDataService.lookupList = {};
    this.smDataService.currentWorkOrder = null;
    this.smDataService.currentWorkOrderScopeData = null;
    this.smDataService.currentScopeSettings = null;
    this.smDataService.scopeNoData = false;
    this.smDataService.isCloseOut = false;
    this.smDataService.completedList = {};
    this.smDataService.serviceDetailsFromGrid = false;
    this.smDataService.serviceDetailsFromDetails = false;
    this.smDataService.isCollectSignature = false;
    this.smDataService.collectPayment = false;
    this.smDataService.isDrillDown = false;
    this.smDataService.isClockOut = false;
    if (loadTrip) {
      this.smDataService.tripList = null;
      this.smDataService.tripListFiltered = null;
      this.eventService.broadcast('smGetTrip');
    }
    if (clockOut) {
      this.eventService.broadcast("smClockOutAction");
    }
  }

  public removeSession() {
    sessionStorage.removeItem("currentWorkOrder");
    sessionStorage.removeItem("currentScope");
    sessionStorage.removeItem("lastScroll");
    sessionStorage.removeItem("fromDatePicker");
    sessionStorage.removeItem("toDatePicker");
    sessionStorage.removeItem("isDrillDown");
    sessionStorage.removeItem("unscheduled");
    sessionStorage.removeItem("sortValue");
    sessionStorage.removeItem("searchText");

    sessionStorage.removeItem("stayServiceDetails"); 
    sessionStorage.removeItem("SMWODashToManID");
    sessionStorage.removeItem("SMWODashToManIDWithTrip");
  }

  public async completeTrip(isCollectSignature) {
    let modalRef = this.ngbModalService.open(CompleteTripModalComponent, { size: 'md', backdrop: 'static' });
    modalRef.componentInstance.currentTrip = this.smDataService.currentWorkOrder;
    modalRef.componentInstance.lookup = this.smDataService.lookupList;
    modalRef.componentInstance.clockStatus = this.smDataService.clockInStatus;
    modalRef.componentInstance.isCollectSignature = isCollectSignature;
    modalRef.result.then((result) => {
      /*
          $scope.closeDetailsList = []; scopeData, tasksList, idList, selectedTasksList, selectedTaskItem, completedList, savedFiles, templateList
      */

      if (!result.justComplete) {
        this.timeoutService.refreshTimeout();
        this.utilityService.openModal();
        this.smDataService.isCloseOut = true;
        this.smDataService.tempClose = [];
        this.smDataService.closeDetailsList = [];
        this.smDataService.signList = [];
        this.smDataService.signCount = 0;
        this.smDataService.closeOutTotalList = [];
        this.smDataService.isCollectSignature = isCollectSignature
        this.smDataService.revisitRequired = result.revisitRequired;
        this.smDataService.revisitReason = result.revisitReason;
        this.smDataService.revisitNotes = result.revisitNotes;
        this.smDataService.loadAttachData = result.loadAttachData;
        this.smDataService.collectPayment = result.collectPayment;
        this.smDataService.bypassAttach = result.bypassAttach;
        this.smDataService.tempCloseExcludeForInvoice = result.tempCloseExcludeForInvoice;

        result.closeList.forEach((val, key) => {
          if (val.IsClose) {
            this.smDataService.tempClose.push(val);
            this.smDataService.closeDetailsList.push({});
          }
        })
        this.smDataService.totalTripCharge = 0;
        this.smDataService.totalTaxCharge = 0;
        this.smDataService.taskShowComplete = true;
        this.smDataService.numberOfCalls = (5 * this.smDataService.tempClose.length) + 1;
        if (this.smDataService.currentWorkOrder.TripNotes != null && this.smDataService.currentWorkOrder.TripNotes != "")
          this.smDataService.currentWorkOrder.TripNotesHTML = this.smDataService.currentWorkOrder.TripNotes;
        else {
          this.smDataService.currentWorkOrder.TripNotesHTML = null;
        }

        this.smService.getSettingsBySMCo(this.smDataService.tempClose[0].SMCo).then((response: any) => {
          this.smDataService.currentScopeSettings = response[0];
          this.getSignature();
        });
      } else {
        this.resetPage(true, false, true);
        return (result.success);
      }
    });
  }

  public async manageTripNoteUpdate(timeStampFromModal, data, newNote) {
    var tripNote = null;
    if (timeStampFromModal) {
      tripNote = newNote
    } else {
      if (this.smDataService.currentScopeSettings?.TripNotesVisibilty == "Date") {
        tripNote = null;
      } else {
        tripNote = data.TripNotes;
      }
    }
    if (this.smDataService.enablePWA) {
      if (!this.smDataService.currentOnline && navigator.serviceWorker.controller != null)
        navigator.serviceWorker.controller.postMessage({ shouldOfflineSync: false, sMTripID: data.SMTripID, tripNotes: tripNote, workOrderDescription: data.WorkOrderDescription, tripDescription: data.TripDescription, installDatabase: false, storeOfflineSyncTrip: false })
    }
    await this.smService.updateTripNotes(data.SMTripID, tripNote, data.WorkOrderDescription, data.TripDescription).then((response: any) => {
      if (response.success) {
        this.smDataService.tempOldTripNotes = null;
        data.TripNotes = response.data;
        data.TripNotesHTML = data.TripNotes;
      }
      if (!response.success && this.smDataService.tempOldTripNotes != null)
        data.TripNotes = this.smDataService.tempOldTripNotes
      this.smDataService.saveResult = response;
      return response;
    }, (error) => {
      if (!this.smDataService.currentOnline) {
        this.smDataService.tempOldTripNotes = null
        let indexdb = window.indexedDB.open("KDS_SM_DB", this.smDataService.indexedDBVersion);
        indexdb.onsuccess = () => {
          let db = indexdb.result;
          let transaction = db.transaction("SM_GetWorkOrderTripsNotHistory", "readwrite");
          let storage = transaction.objectStore("SM_GetWorkOrderTripsNotHistory");
          var keyRangeValue = IDBKeyRange.only(data.SMTripID);

          let cursor = storage.openCursor(keyRangeValue);
          cursor.onsuccess = (event: any) => {
            var curData = event.target.result;
            var tempData = curData.value;
            tempData.TripNotes = data.TripNotes;
            tempData.WorkOrderDescription = data.WorkOrderDescription;
            tempData.TripDescription = data.TripDescription;
            curData.update(tempData);
          }
        }
      }
    });
  }
}
